import { shallowMount } from "@vue/test-utils";
import ModalConfirmarTelefono from "@/components/core/ModalConfirmarTelefono";

describe("ModalConfirmarTelefono component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(ModalConfirmarTelefono);
  });

  it("Renders del component ModalConfirmarTelefono", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
